<template>
    <el-card class="box-card">
        <el-row>
            <p style="float: left; font-weight: 1000; font-size: 16px">工单信息</p>
            <el-button style="float: right" type="primary" @click="updateDetectnOrder()" v-if="">编辑</el-button>
            <!-- <el-button style="float: right;" type="primary" @click="">导出</el-button> -->
        </el-row>
        <el-divider></el-divider>
        <el-row>
            <el-form :model="order" label-width="100px" inline class="unitWidth">
                <el-form-item label="工单编号">
                    <el-input disabled style="width: 200px" v-model="order.adoCode"></el-input>
                </el-form-item>
                <el-form-item label="设备编号">
                    <el-input disabled style="width: 200px" v-model="order.devCode"></el-input>
                </el-form-item>
                <el-form-item label="计划人员">
                    <el-input disabled style="width: 200px" v-model="order.planUser"></el-input>
                </el-form-item>
                <el-form-item label="计划日期">
                    <el-date-picker style="width: 200px" v-model="order.planTime" type="date" placeholder="选择日期"
                                    value-format="yyyy-MM-dd"></el-date-picker>
                </el-form-item>

                <el-form-item label="状态">
                    <el-input disabled style="width: 200px" v-model="order.isComplete == 1 ? '已完成' : '未完成'"></el-input>
                </el-form-item>
                <el-form-item label="实施人员">
                    <el-input disabled style="width: 200px" v-model="order.actionName"></el-input>
                </el-form-item>
                <el-form-item label="实施日期">
                    <el-input disabled style="width: 200px" v-model="order.acoActionTime"></el-input>
                </el-form-item>
                <el-form-item label="是否验收">
                    <el-input disabled style="width: 200px" v-model="order.pass ? '是' : '否'"></el-input>
                </el-form-item>
            </el-form>
        </el-row>

        <el-collapse v-model="activeName" v-for="(report, index) in order.map.reports">
            <el-collapse-item :title="report.abilityDetectnItemPO.adiItem" name="1">
                <el-form label-width="100px" inline class="unitWidth">
                    <el-form-item label="检测项目">
                        <el-input disabled style="width: 200px"
                                  v-model="report.abilityDetectnItemPO.adiItem"></el-input>
                    </el-form-item>
                    <el-form-item label="检测方法">
                        <el-input disabled style="width: 200px"
                                  v-model="report.abilityDetectnItemPO.adiMethod"></el-input>
                    </el-form-item>
                    <el-form-item label="判断标准">
                        <el-input disabled style="width: 200px"
                                  v-model="report.abilityDetectnItemPO.adiJudgment"></el-input>
                    </el-form-item>

                    <el-form-item label="产品名称">
                        <el-input style="width: 200px" v-model="report.prodName"></el-input>
                    </el-form-item>
                    <el-form-item label="产品批次">
                        <el-input style="width: 200px" v-model="report.prodBatch"></el-input>
                    </el-form-item>
                    <el-form-item label="工序号">
                        <el-input style="width: 200px" v-model="report.procCode"></el-input>
                    </el-form-item>
                    <el-form-item label="工序名称">
                        <el-input style="width: 200px" v-model="report.procName"></el-input>
                    </el-form-item>

                    <el-form-item label="检测原因">
                        <el-select style="width: 200px" v-model="report.adrReason">
                            <el-option value="预验收">预验收</el-option>
                            <el-option value="终验收">终验收</el-option>
                            <el-option value="定期测定">定期测定</el-option>
                            <el-option value="大修理">大修理</el-option>
                            <el-option value="其他">其他</el-option>
                        </el-select>
                    </el-form-item>

                    <!-- <template v-if="report.abilityDetectnItemPO.adiType == 'CMK'">
                            <el-form-item label="图片" enctype="multipart/form-data" style="display: inline-block;">
                                    <div class="listCon">
                                        <div class="photolist">
                                            <ul class="clearfix">
                                                <li >
                                                    <div class="claerimgbox" v-if="cmkImgiList.length>0" v-for='(item ,index ) in cmkImgiList' >
                                                        <span class="clearimg" @click="cmkDelImg(item,index)">X</span>
                                                        <img :src="item.url" width="80PX;" height="80PX;">
                                                    </div>
                                                </li>
                                                <li style="position:relative" >
                                                    <img src="" /><input id="uploadEventFile" style="width: 200px;" @change="cmkUpload($event)"  type="file" accept="image/jpg,image/jpeg,image/png"/>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                            </el-form-item>
                        </template> -->
                    <el-form-item label="CMK判定值">
                        <el-input style="width: 200px" v-model="report.cmkMin"></el-input>
                    </el-form-item>
                    <el-form-item label="标准差">
                        <el-input disabled style="width: 200px" v-model="report.mathSdev"></el-input>
                    </el-form-item>
                    <el-form-item label="平均值">
                        <el-input disabled style="width: 200px" v-model="report.mathAvg"></el-input>
                    </el-form-item>
                    <el-form-item label="公差带">
                        <el-input disabled style="width: 200px" v-model="report.mathTdev"></el-input>
                    </el-form-item>
                    <el-form-item label="偏移量">
                        <el-input disabled style="width: 200px" v-model="report.mathDev"></el-input>
                    </el-form-item>
                    <el-form-item :label="report.abilityDetectnItemPO.adiType + '值'">
                        <el-input disabled style="width: 200px" v-model="report.mathValue"></el-input>
                    </el-form-item>
                    <el-form-item label="检验结果">
                        <el-input disabled style="width: 200px" v-if="order.pass == true" value="合格">合格</el-input>
                        <el-input disabled style="width: 200px" v-if="order.pass == false" value="不合格">不合格</el-input>
                    </el-form-item>
                </el-form>
                <el-form>
                    <el-tabs type="card" @tab-click="handleClick(report.map.values)">
                        <el-tab-pane label="检验记录">
                            <table v-if="'undefined' != report.map.values" id="checkRecord">
                                <tr style="width: 5vw; height: 3vw; border-bottom: 1px solid #e4e5e6; background-color: #eef3ff">
                                    <td>组号</td>
                                    <td>均值</td>
                                    <td>差值</td>
                                    <td>统计</td>
                                    <td v-if="report.abilityDetectnItemPO.adiType == 'GRR'"
                                        :colspan="report.groupAmount * 2">结果值
                                    </td>
                                    <td v-if="report.abilityDetectnItemPO.adiType != 'GRR'"
                                        :colspan="report.groupAmount">结果值
                                    </td>
                                </tr>
                                <tr v-for="(value, index) in report.map.values">
                                    <td>{{ value.groupNo }}</td>
                                    <td>{{ value.mathAvg }}</td>
                                    <td>{{ value.mathDiff }}</td>
                                    <td>{{ value.mathSum }}</td>
                                    <td v-for="(value, index) in value.valueList">
                                        {{ value }}
                                    </td>
                                </tr>
                            </table>
                        </el-tab-pane>
                        <el-tab-pane label="检验记录(图形化)" name="second">
                            <div id="main" style="width: 800px; height: 500px" :v-if="chartShow"></div>
                        </el-tab-pane>
                    </el-tabs>
                </el-form>
            </el-collapse-item>
        </el-collapse>
    </el-card>
</template>
<script>
    import DetectnOrder from '../../../api/detectnorder.js'
    // 引入基本模板
    let echarts = require('echarts/lib/echarts')
    // 引入柱状图组件
    require('echarts/lib/chart/bar')
    // 引入提示框和title组件
    require('echarts/lib/component/tooltip')
    require('echarts/lib/component/title')
    require('echarts/lib/component/legend')

    export default {
        name: 'abilityDetectnOrderInfo',
        data: function() {
            return {
                order: {},
                values: [],
                activeName: '1',
                chart: {
                    groupNos: [],
                    mathAvgs: []
                },
                mathAvg: 0,
                chartShow: false,
                detectnOrder: {
                    adoCode: '',
                    planTime: '',
                    detectnReports: []
                },
                mathValue: {
                    maxValue: 0,
                    minValue: 0
                }
            }
        },
        activated() {
            this.init()
        },
        created() {
            this.init()
        },
        methods: {
            updateDetectnOrder() {
                var self = this
                self.detectnOrder.adoCode = self.order.adoCode
                self.detectnOrder.planTime = self.order.planTime
                self.detectnOrder.detectnReports = self.order.map.reports
                let options = {
                    method: 'POST',
                    url: DetectnOrder.alterAbilityDetectnOrder,
                    data: self.detectnOrder
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        self.$message.success('更新工单成功!')
                    } else {
                        self.$message.error(response.message)
                    }
                })
            },
            init(count) {
                var self = this
                if (self.$route.query.order) {
                    self.order = JSON.parse(self.$route.query.order)
                    //console.log('结果值会输出吗---------'+JSON.stringify(self.order.map.reports[0].map.value));
                    self.values = JSON.stringify(self.order.map.reports[0].map.value)
                }
            },
            handleClick(data) {
                if ('undefined' == data) {
                    return
                }
                this.chart.groupNos = []
                this.chart.mathAvgs = []

                for (let value in data) {
                    this.chart.groupNos.push(data[value].groupNo)
                    this.chart.mathAvgs.push(data[value].mathAvg)
                    this.mathAvg = this.mathAvg + data[value].mathAvg

                }

                this.loadIcon(this.chart)
            },
            loadIcon(data) {
                var option = this.creatObject(data)
                this.chartShow = true
                // 基于准备好的dom，初始化echarts实例
                let myChart = echarts.init(document.getElementById('main'))
                // 绘制图表
                myChart.setOption(option)
            },
            creatObject: function(data) {

                var mathValue = this.getMathValue(data.mathAvgs)

                var option = {
                    xAxis: {
                        type: 'category',
                        data: data.groupNos
                    },
                    yAxis: {
                        type: 'value',
                        scale: true,
                        max: mathValue.maxValue,
                        min: mathValue.minValue,
                        minInterval: 0.2
                    },
                    series: [{
                        name: '能力检测',
                        data: data.mathAvgs,
                        type: 'line',
                        color: ['red'],
                        markPoint: {
                            data: [
                                {
                                    type: 'max'
                                },
                                {
                                    type: 'min'
                                }
                            ]
                        },
                        markLine: {
                            data: [
                                {
                                    type: 'average'
                                }
                            ]
                        }

                    }]
                }
                return option
            },
            getMathValue: function(data) {
                let mathValue = {
                    maxValue: 0,
                    minValue: 0
                }

                // 获取最大值
                var max = data[0]
                for (var i = 1; i < data.length; i++) {
                    var cur = data[i]
                    cur > max ? max = cur : null
                }
                console.log(Math.ceil(max))

                // 获取最小值
                var min = data[0]
                for (var i = 1; i < data.length; i++) {
                    var cur = data[i]
                    cur < min ? min = cur : null
                }
                console.log(Math.floor(min))

                mathValue.maxValue = Math.ceil(max)
                mathValue.minValue = Math.floor(min)
                return mathValue
            }


        }
    }
</script>
<style lang="scss" scoped>
    .box-card {
        width: 70%;
    }

    .formlist {
        float: right;
        border: #000000 1px;
    }

    //  #checkRecord td {
    //      border:1px solid #0094ff;
    //      width: 50px;
    //      height:50px;
    //  }

    table {
        width: 100%;
    }

    th {
    }

    td {
        border-right: 1px solid #e4e5e6;
        border-bottom: none;
        font-size: 11px;
        padding: 6px 6px 6px 12px;
        color: #4f6b72;
    }

    td.alt {
        background: #f5fafa;
        color: #797268;
    }
</style>
